const MuiInputLabel = {

};

export default MuiInputLabel;



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/overrides/MuiInputLabel.js